// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { HireCreditLimit } = require('components/hire/hireCreditLimit/hireCreditLimit');
const { HirePaymentMethod } = require('components/hire/hirePaymentMethod/hirePaymentMethod');
import { DisclaimerPersonalInfo } from 'components/hire/cardViaT/disclaimerPersonalInfo/disclaimerPersonalInfo';

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @ constants
const {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    THIRD_STEP,
    WIZARD_THIRD_STEP
} = require('constants/index');
const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');
const {
    CREDIT_CARD_REVOLVING_PROCESS,
} = require('constants/flagBasedFeatures');

class HireCardOpenCreditStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.onCreditLimitModalContinue = this.onCreditLimitModalContinue.bind(this);
    }

    componentDidMount() {
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.filterAccounts(), immAccounts.get('byId'));
        if (allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    onCreditLimitModalContinue() {
        const {
            immHireCreditLimit,
            setHireCreditLimit,
            toggleCreditLimitModal,
            validate,
        } = this.props;

        setHireCreditLimit(immHireCreditLimit.get('creditLimitModalValue'), true);
        toggleCreditLimitModal(false);
        validate(WIZARD_THIRD_STEP, true);
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
            ACCOUNT_INTERVENTION_REPRESENTATIVE
        ];
        const accountsIndexes = immAccounts.get('byOrder').filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    render() {
        const {
            handleAccountChange,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireCardOpenCredit,
            immHireCreditLimit,
            immHirePaymentMethod,
            isInactiveAccountsEnabled,
        } = this.props;
        const immStep3 = immHireCardOpenCredit.getIn(['steps', THIRD_STEP]);
        const accountErrorMsgVisible = immStep3.get('accountIsDirty') && !immStep3.get('accountIsValid');
        const accountErrorMsg = formatText('hireCardOpenCredit-step3SelectAccountError');
        const accountLabel = formatText('hireCardOpenCredit-step3SelectAccount');

        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-visaOpenLinkUrl');

        const selectedImageId = immHireCardImageSelector.get('selectedImageId');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        const messageVisible = !immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
         return (
            <article className="hire-card-open-credit-step-three">
                <FormattedText
                    className="hire-card-open-credit__step-title"
                    value="hireCardOpenCredit-step3Title"
                />
                <DropdownAccounts
                    accountsIndexes={this.filterAccounts()}
                    currentAccountId={immStep3.get('accountId')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    onAccountChange={handleAccountChange}
                    optionalElement={DisclaimerPersonalInfo()}
                    showAvailableBalance
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    loading={isBlockedAccountsLoading}
                />
                <h4 className="hire-card-open-credit__section-header">
                    <FormattedText value="hireCardOpenCredit-step3CardData" />
                </h4>
                <HireCreditLimit
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    productSubType="801"
                    productType="500"
                    referenceStandard={`0000${selectedImageId.substring(10)}`}
                    handleModalContinue={this.onCreditLimitModalContinue}
                />
                <HirePaymentMethod
                    immCreditLimit={immHireCreditLimit}
                    immGlobalVariables={immGlobalVariables}
                    immHirePaymentMethod={immHirePaymentMethod}
                />
                <OKMessage
                    type="informative"
                    visible={messageVisible}
                >
                    <FormattedText value="disclaimerPersonalInfo-visaOpenMsg" />
                    &nbsp;
                    <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                        <FormattedText value="disclaimerPersonalInfo-visaOpenLinkText" />
                    </OKLink>
                </OKMessage>
            </article>
        );
    }
}

HireCardOpenCreditStep3.propTypes = {
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardOpenCredit: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
};

module.exports = HireCardOpenCreditStep3;
